import * as React from 'react'
import { Header, Image } from 'semantic-ui-react'
import pic from './author.png'
import ContentMol from '../../../molecules/content'
import ProfileHistoryMol from '../../../molecules/profileHistory'
import HomeDetailHistoryOrg from '../detailHistory'

export default class ProfileOrg extends React.Component<{}, {}> {
  public render() {
    return (
      <div>
        <ContentMol title="プロフィール・略歴">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <div style={{ width: 300 }}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Image
                  src={pic}
                  size="small"
                  style={{
                    height: '50%',
                    width: '50%',
                  }}
                />
              </div>
              <HomeDetailHistoryOrg style={{ padding: 20 }} />
            </div>
            <div>
              <Header>劉穎（リュウエイ） 翻訳家・語学講師・薬膳/茶芸師</Header>
              <ProfileHistoryMol
                history={[
                  [
                    '1986年12月',
                    '中国黒竜省ハルピン市出身、中国残留孤児3世として来日',
                  ],
                  ['1997年3月', '大阪外国語大学国際文化学科卒業（学士）'],
                  ['2015年3月', '佛教大学大学院博士前期課程修了（修士）'],
                  ['2018年3月', '佛教大学大学院博士後期課程単位取得満期退学'],
                  ['2018年4月', '佛教大学文学研究員'],
                ]}
              />
              <Header>免許・資格</Header>
              <ProfileHistoryMol
                history={[
                  ['1991年3月5日', 'ISS日中通訳通信教育修了'],
                  ['1992年2月4日', '花道師範「女流いけばな展」二度入賞'],
                  ['1998年3月10日', '高等学校教諭一種免許（国語・中国語）'],
                  ['2012年6月5日', '薬膳師資格取得'],
                  ['2012年9月1日', '茶芸師職業資格'],
                  ['2019年12月21日', '介護職員初任者'],
                ]}
              />
            </div>
          </div>
        </ContentMol>
      </div>
    )
  }
}
